import Controller from '@ember/controller';
import type MarketSettingsCostRoute from 'lumen/routes/market/settings/cost';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCostController extends Controller {
  declare model: ModelFrom<MarketSettingsCostRoute>;

  /**
   * TODO(PIN-1242): return `!access.hasCostSettingsEditAccess` once the flag exists.
   */
  get isReadOnly(): boolean {
    return false;
  }
}
